/**
 * Store réactif Svelte 5 (runes) pour l'état d'authentification.
 *
 * Importé depuis n'importe quel composant pour réagir au sign-in / sign-out.
 * Mutations via les helpers de oauth.ts (handleCallback, signOut, etc.).
 *
 * Note : fichier .svelte.ts → Svelte 5 autorise les runes hors de .svelte.
 */

interface AuthState {
  signedIn: boolean;
  email: string | null;
}

export const authState = $state<AuthState>({
  signedIn: false,
  email: null,
});
